export default __webpack_public_path__ + "static/media/00.e660b583.jpg";